export default __webpack_public_path__ + "static/media/a3.3ba42a5d.png";